import { OrganizationInviteDto, SourcingEventDto } from "../../autogen/bff-api";

export const invitedOrganizations = (event: Pick<SourcingEventDto, "eventContext">): OrganizationInviteDto[] => {
  const context = event.eventContext;
  switch (context.type) {
    case "Private":
    case "MiniCompetition":
      return context.organizationInvites;
    default:
      return [];
  }
};
